import styled from 'styled-components'

import Illust from '@/components/cell/atoms/Illust'
import { IllustPack } from '@/components/cell/atoms/Illust/enum'
import Button from '@/components/cell/molecules/Button'

export interface Props {
  text: {
    message: string
    button: string
  }
  onClickButton: () => void
}

const EmptyState = ({ text, onClickButton }: Props): JSX.Element => {
  return (
    <div
      className="flex flex-col items-center bg-white text-center py-58"
      role="button"
      tabIndex={0}
      onClick={onClickButton}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClickButton()
        }
      }}
    >
      <StyledIllust name={IllustPack.EMPTYSTATE} />

      <p className="text-description2 mb-4">{text.message}</p>

      <StyledButton color="primary" size="medium" onClick={onClickButton}>
        {text.button}
      </StyledButton>
    </div>
  )
}

const StyledIllust = styled(Illust)`
  margin-bottom: 16px;
`
const StyledButton = styled(Button)`
  margin-bottom: 16px;
`

export default EmptyState
